import React from 'react';
import intl from 'react-intl-universal';
import { defaultRowCount } from '../../../constants/listViewLayoutConstants';
import { DWHUserCallsResultType } from '../../../interfaces/Dashboard';
import { exportToCsv } from '../../../utils/csv-utils';
import { parseRoomSystemDrillDownDataForExport } from '../../../utils/exportUtils';
import ListViewComponent from '../../ListView/ListViewComponent';
import ListViewLayout from '../../ListViewLayout/ListViewLayout';
import DrilldownHeader from '../Common/DrilldownHeader2';
import { Query, QueryResult } from 'react-apollo';
import RoomTotalsQuery from 'queries/dashboard/RoomTotalsQuery.gql';
import { RowInfo } from 'react-table';
import _get from 'lodash/get';
import { Moment } from 'moment';
import SearchBar from '../../../containers/Search/SearchBar';
import * as styles from './UsersTable.scss';

interface Props {
  dateStart: Moment;
  dateEnd: Moment;
  searchString: string;
  pageNumber: number;
  onSelect: Function;
}

class RoomSystemsTable extends React.Component<Props> {

  handleExportToCsv = (data: DWHUserCallsResultType[]) => {
    const exportData = data.sort(
      (a: DWHUserCallsResultType, b: DWHUserCallsResultType) => {
        return b.totalMinutes - a.totalMinutes;
      }).map(parseRoomSystemDrillDownDataForExport);
    exportToCsv(intl.get('roomSystems'), exportData);
  }

  getFilteredData = (data: DWHUserCallsResultType[]) => {
    const { searchString } = this.props;
    if (searchString) {
      return data.filter(record => record.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
    }
    return data;
  }

  render() {
    const queryVars = {
      dateStart: this.props.dateStart.format('YYYY-MM-DD'),
      dateEnd: this.props.dateEnd.format('YYYY-MM-DD')
    };
    return (
      <Query query={RoomTotalsQuery} variables={{ ...queryVars }} fetchPolicy="network-only">
        {({ loading, error, data, refetch }: QueryResult<object>) => {
          const records = this.getFilteredData(_get(data, 'roomTotalsTable', []));
          return (
            <ListViewLayout
              error={_get(error, 'message', undefined)}
              hideHeader={true}
              isFetching={loading}
              title={intl.get('headerRoomSystemTotals')}
              numberOfPages={Math.ceil(records.length / defaultRowCount)}
            >
              <SearchBar/>

              <DrilldownHeader
                fetchData={refetch}
                onExportClick={() => this.handleExportToCsv(records)}
              />

              {loading ? null :
                <ListViewComponent
                  data={records}
                  columns={
                    [{
                      Header: intl.get('tableHeaderName'),
                      accessor: 'name',
                      Cell: (row: RowInfo) => (
                        <a
                          className={styles.editButton}
                          onClick={() => this.props.onSelect(row.original.userId)}
                        >
                          {row.original.name}
                        </a>
                      )
                    }, {
                      Header: intl.get('minutes'),
                      accessor: 'totalMinutes',
                    }, {
                      Header: intl.get('calls'),
                      accessor: 'totalCalls'
                    }]
                  }
                  showPagination={false}
                  maxRows={defaultRowCount}
                  pageNumber={this.props.pageNumber}
                  defaultSorted={[{
                    id: 'totalMinutes',
                    desc: true
                  }]}
                />
              }
            </ListViewLayout>
          );
        }}
      </Query>
    );
  }
}

export default RoomSystemsTable;
